import {
    GESTION_OPERATIVA_DELETE_BILLS_BEGIN,
    GESTION_OPERATIVA_DELETE_BILLS_DISMISS_ERROR
} from '../constants';


export function deleteBills( id ) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_DELETE_BILLS_BEGIN,
            data: id
        })
    }
}

export function dismissDeleteBillsError() {
    return {
      type: GESTION_OPERATIVA_DELETE_BILLS_DISMISS_ERROR
    }
}
